/** 数据中心 → 萃茶机数据 → 物料损耗（patch 152；rename patch 162；原「泡茶机物料」） */
export const TEA_MACHINE_MATERIAL_MENU_IDS = {
  page: 990412,
  /** coffee_menu parent en_name */
  parentEnName: 'dataOfTeaExtractorMachine'
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/teaMachineMaterial.js